import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.08333 2.5V0.749997C3.08333 0.595288 3.14479 0.446915 3.25419 0.337518C3.36358 0.228122 3.51196 0.166664 3.66667 0.166664H10.6667C10.8214 0.166664 10.9697 0.228122 11.0791 0.337518C11.1885 0.446915 11.25 0.595288 11.25 0.749997V8.91666C11.25 9.07137 11.1885 9.21975 11.0791 9.32914C10.9697 9.43854 10.8214 9.5 10.6667 9.5H8.91667V11.25C8.91667 11.572 8.65417 11.8333 8.32925 11.8333H1.33742C1.26049 11.8338 1.18423 11.819 1.11302 11.7899C1.04181 11.7608 0.977053 11.718 0.922467 11.6638C0.867882 11.6095 0.824546 11.5451 0.794948 11.4741C0.765351 11.4031 0.750075 11.3269 0.75 11.25L0.75175 3.08333C0.75175 2.76133 1.01425 2.5 1.33917 2.5H3.08333ZM1.91842 3.66666L1.91667 10.6667H7.75V3.66666H1.91842ZM4.25 2.5H8.91667V8.33333H10.0833V1.33333H4.25V2.5Z"
      fill="#138EFF"
    />
  </svg>
);
export default SVGComponent;
